import styled from 'styled-components';

import Button from '/components/ui/buttons/Button';
import { colors } from '/css';

interface Props {
    locked: boolean;
    onDisableLock: () => void;
}

export default function ChangeLock({ locked, onDisableLock, ...props }: Props) {
    return (
        <Wrapper
            id="change-lock"
            style={{ display: locked ? 'flex' : 'none' }}
            {...props}
        >
            <div>
                <p>
                    Obs! Listen over elektromateriell har blitt endre manuelt.
                    Hvis du endrer på svarene på spørsmålene nå så vil en ny
                    liste lages som overstyrer den nåværende listen.
                </p>
                <Button size="small" onClick={onDisableLock}>
                    Jeg forstår
                </Button>
            </div>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.9);
    z-index: 49;
    display: flex;
    align-items: center;
    justify-content: center;
    > div {
        max-width: 80%;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        color: ${colors.orange};
    }
    p {
        margin-bottom: 24px;
    }
`;
